/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RefundedbagUpdateRecordParam model module.
 * @module model/RefundedbagUpdateRecordParam
 * @version 1.0
 */
class RefundedbagUpdateRecordParam {
    /**
     * Constructs a new <code>RefundedbagUpdateRecordParam</code>.
     * @alias module:model/RefundedbagUpdateRecordParam
     */
    constructor() { 
        
        RefundedbagUpdateRecordParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RefundedbagUpdateRecordParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RefundedbagUpdateRecordParam} obj Optional instance to populate.
     * @return {module:model/RefundedbagUpdateRecordParam} The populated <code>RefundedbagUpdateRecordParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RefundedbagUpdateRecordParam();

            if (data.hasOwnProperty('bagType')) {
                obj['bagType'] = ApiClient.convertToType(data['bagType'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('quantity')) {
                obj['quantity'] = ApiClient.convertToType(data['quantity'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} bagType
 */
RefundedbagUpdateRecordParam.prototype['bagType'] = undefined;

/**
 * @member {String} date
 */
RefundedbagUpdateRecordParam.prototype['date'] = undefined;

/**
 * @member {Number} quantity
 */
RefundedbagUpdateRecordParam.prototype['quantity'] = undefined;

/**
 * @member {Number} userId
 */
RefundedbagUpdateRecordParam.prototype['userId'] = undefined;






export default RefundedbagUpdateRecordParam;

